import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { useFormikContext } from "formik";

import {
  CftLayout,
  CftHeader,
  CftSection,
  CftFooter,
  CftReportProgress,
  CftActionsButtons,
  CftExportReport,
  CftTank,
} from "../../../components";
import routes from "../../../utils/cftRoutes";
import { useCft } from "../../../utils/CftProvider";

import FertilizersBothCalcForm, {
  FertilizersBothCalcFormContext,
} from "../../../forms/farmlands/bothCalc/FertilizersBothCalcForm/FertilizersBothCalc.form";

function FertilizersBothCalcPage() {
  const { t } = useTranslation(["cft"]);
  const history = useHistory();
  const { submitForm, values, isSubmitting } = useFormikContext();
  const { saveBothCalc, meta } = useCft();

  return (
    <CftLayout
      header={
        <CftHeader
          progressValue={28}
          cropName={meta.title.bothCalc}
          actions={
            <CftTank
              display="flex"
              flexDirection="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <CftExportReport type="bothCalc" />

              <CftActionsButtons.CancelButton
                onClick={() => {
                  saveBothCalc({
                    fertilizers: values,
                  });
                  history.push(routes.FARMLANDS.BOTH_CALC.MAIN);
                }}
              />
            </CftTank>
          }
        />
      }
      footer={
        <CftFooter
          isPending={isSubmitting}
          text={t("cft:fertilizers.title", "Nawozy")}
          onBack={() => history.push(routes.FARMLANDS.BOTH_CALC.SOIL)}
          onNext={submitForm}
        />
      }
    >
      <CftSection
        header={
          <>
            <h3>{t("cft:fertilizers.title", "Nawozy")}</h3>
            <p>
              {t(
                "cft:fertilizers.subtitle",
                "Wprowadź dane dotyczące nawozów oraz środków ochrony roślin przed, w trakcie i po uprawie."
              )}
            </p>
          </>
        }
      >
        <FertilizersBothCalcForm />
        <CftReportProgress type="bothCalc" />
      </CftSection>
    </CftLayout>
  );
}

export default () => {
  return (
    <FertilizersBothCalcFormContext>
      <FertilizersBothCalcPage />
    </FertilizersBothCalcFormContext>
  );
};
